import React from 'react';

// Layout container from SyncUp component library
import { ContentContainer } from '@tmobile/tmo-bps-syncup-web-component-lib';

// Authorization wrapper to restrict access based on user roles
import Authorized from '../../auth/Authorized';

// Application role constants
import { SUA_ROLES } from '../../utils/app_constants';

// Feature Flags main component
import FeatureFlags from '../../components/featureFlag/FeatureFlags';

// Reusing existing container styles for consistent layout
import style from '../../components/appVersions/AppVersionsList.module.css';

function FeatureFlagsPage() {
  return (
    /**
     * Authorized component ensures only users with
     * specified roles can access this page
     */
    <Authorized
      roles={[
        SUA_ROLES.ADMIN,
        SUA_ROLES.MOBILE_APP_DEVS,
        SUA_ROLES.SYNCUP_DPI, // TO-DO: Remove SYNCUP_DPI after testing
        SUA_ROLES.PO,
        SUA_ROLES.PETS_ADMIN,
        SUA_ROLES.PETS_DEV,
        SUA_ROLES.PETS_PO,
        SUA_ROLES.TRACKER_ADMIN,
        SUA_ROLES.TRACKER_DEV,
        SUA_ROLES.TRACKER_PO,
        SUA_ROLES.WATCH_ADMIN,
        SUA_ROLES.WATCH_DEV,
        SUA_ROLES.WATCH_PO
      ]}
      // Displays an error modal if user lacks permission
      willShowErrorModal
    >
      {/* Provides consistent page padding and layout */}
      <ContentContainer className={style.container}>
        {/* Feature Flags management UI */}
        <FeatureFlags />
      </ContentContainer>
    </Authorized>
  );
}

// Export page-level component
export default FeatureFlagsPage;
